import { Alumno } from './../../../models/alumno.model';
import { EstadoFactura, FacturaList } from './../../../models/factura.model';
import { CategoriaConcepto } from './../../../models/categoria-concepto.model';
import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { FacturaService } from '../../../services/factura.service';
import { FacturaReporteService } from '../../../services/factura-reporte.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ImpresionService } from 'src/app/services/impresion.service';
import { Factura } from 'src/app/models/factura.model';
import { Escuela } from 'src/app/models/escuela.model';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subscription, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { AlumnoService } from 'src/app/services/alumno.service';
import { AlumnoList } from 'src/app/interfaces/alumno.interface';

@Component({
  selector: 'app-facturas-list',
  templateUrl: './facturas-list.component.html',
  styleUrls: ['./facturas-list.component.css']
})
export class FacturasListComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns = ['cae', 'numero', 'mes', 'alumno', 'montopagar', 'pagado', 'fechapago', 'formaPago', 'tipo', 'estado', 'comentario'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  facturas = [];
  conceptos = [] as CategoriaConcepto[];
  subscriptions: Subscription[] = [];
  pageIndex = 0;
  pageSize = 10; // Defaulting to 10 as per paginator default
  length = 0;
  desde = new Date();
  hasta = new Date();
  filtroCae = '';
  filtroNumero = '';
  sinCae = false;
  inputAlumno = new UntypedFormControl();
  filteredAlumno!: Observable<Alumno[]>;
  escuela!: Escuela;
  alumnos: Array<Alumno> = [];
  alumnoSelectedId = 0;

  private destroy$ = new Subject<void>();
  private searchSubscription?: Subscription;
  private alumnoSubscription?: Subscription;

  constructor(
    private facturaService: FacturaService,
    private impresionService: ImpresionService,
    private facturaReporteService: FacturaReporteService,
    private alumnoService: AlumnoService
  ) { }

  ngOnInit(): void {
    this.escuela = JSON.parse(localStorage.getItem('escuela') || '{}') as Escuela;
    this.filteredAlumno = this.inputAlumno.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  private _filter(value: string): Alumno[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.alumnos.filter(p => p.nombre.toLowerCase().includes(filterValue) || p.apellido.toLowerCase().includes(filterValue) || p.legajo.toLowerCase().includes(filterValue));
    }
    return [];
  }

  displayFn(option: any) {
    if (option)
      return `${option.apellido} ${option.nombre}`;
    else return '';
  }

  doFilterAlumnos() {
    if (this.inputAlumno.value && this.inputAlumno.value.length > 3) {
      let stringFilter = this.inputAlumno.value.toLowerCase();
      this.getData(this.pageIndex, 20, stringFilter);
    }
  }

  getData(pageIndex: number, pageSize: number, filter: string) {
    const dataFilter = { filterLike: filter, gradoId: 0, inactivos: false };
    
    if (this.alumnoSubscription) {
      this.alumnoSubscription.unsubscribe();
    }

    this.alumnoSubscription = this.alumnoService.getAlumnosPorEscuelaYFiltros(pageIndex, pageSize, dataFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((fs: AlumnoList) => {
        this.alumnos = fs.resultList;
      });
  }

  alumnoSelect(alumno: any) {
    this.alumnoSelectedId = alumno.value.id;
  }

  aplicarFiltro() {
    if (!this.inputAlumno.value) {
      this.alumnoSelectedId = 0;
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    this.searchSubscription = this.facturaService.getFacturaEscuelaYFiltro(
      this.escuela.id,
      this.pageIndex,
      this.pageSize,
      this.filtroCae.trim(),
      new Date(this.desde),
      new Date(this.hasta),
      false,
      this.alumnoSelectedId,
      this.filtroNumero.trim(),
      this.sinCae
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((fs: FacturaList) => {
        this.dataSource.data = fs.resultList;
        this.length = fs.total;
        if (this.paginator) {
          this.paginator.length = this.length;
        }
      });
  }

  imprimir(fc: Factura) {
    const sub = this.facturaService.getFacturaPorIdConRelaciones(fc.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result.resultList.length === 1) {
          this.impresionService.generatePDF('', result.resultList[0], {});
        }
      });
    this.subscriptions.push(sub);
  }

  anular(fc: Factura) {
    if (confirm('Esta seguro de anular esta factura?')) {
      fc.fechaAnulacion = new Date();
      fc.estado = EstadoFactura.anulada;

      if (confirm('Desea actualizar la cuenta corriente para este periodo?')) {
        let cuenta = fc.cuentaCorriente;
        cuenta.pagado = Number(cuenta.pagado) - Number(fc.monto);
      }
    }
  }

  getServerData(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex + 1;
      this.pageSize = event.pageSize; // Removed the +1 size increase which caused unexpected paging behavior
      this.aplicarFiltro();
    }
    return event;
  }

  desdeChange(evento: Date) {
    this.desde = evento;
  }

  hastaChange(evento: Date) {
    this.hasta = evento;
  }

  // Reporte que da un listado de facturas con el filtro aplicado.
  getExcelFacturas(){
    this.facturaReporteService.getExcelFacturas(this.escuela.id, this.filtroCae,  new Date(this.desde), new Date(this.hasta), true, this.alumnoSelectedId);
  }
  // Reporte que da un listado de facturas con deuda con el filtro aplicado.
  getExcelFacturasConDeuda(){
    this.facturaReporteService.getExcelFacturasConDeuda(this.escuela.id, this.filtroCae, new Date(this.desde), new Date(this.hasta), true);
  }
  // Reporte que da un listado de facturas agrupdas por alumno con el filtro aplicado.
  getExcelReporteAgrupadoAlumno(){
    //this.cuentaCorrienteService.getCuentaCorrienteEscuelaYFiltroConDeuda(this.escuela.id, this.filtroTexto, new Date(this.desde), new Date(this.hasta), true);
  }

  // Reporte que da un listado de facturas a futuro, lo que no tiene factura es una cc sin pagar.
  getExcelAranceles(){
    this.facturaReporteService.getExcelAranceles(this.escuela.id, new Date(this.desde).getFullYear());
  }

  getExcelCajaFechas(){
    this.facturaReporteService.getExcelFacturasIngresoEgreso(this.escuela.id, this.filtroCae, new Date(this.desde), new Date(this.hasta), true, false);
  }

  getExcelFacturasCajaDiaria(){
    let desde = new Date(this.desde);
    // desde = startOfDay(desde);
    // let hasta = endOfDay(desde);
    // let hasta = desde.setHours(23);
    // hasta = desde.setMinutes(59);
    // hasta = desde.setSeconds(59);
    // const d = new Date(hasta);
    //let fecha = this.getDate(this.desde);
    this.facturaReporteService.getExcelFacturasIngresoEgreso(this.escuela.id, this.filtroCae, desde.toISOString().substring(10,0), null, true, true);
  }

  getDate(fecha){
    var targetTime = new Date(fecha);
    //get the timezone offset from local time in minutes
    var tzDifference = targetTime.getTimezoneOffset();
    //convert the offset to milliseconds, add to targetTime, and make a new Date
    var offsetTime = new Date(targetTime.getTime() - tzDifference * 60 * 1000);

    return offsetTime;
  }


  // getExcelFacturasIngresoEgresoDia(){
  //   const fechadesde = new Date(this.desde);
  //   let fecha2 = fechadesde.setHours(0);
  //   fecha2 = fechadesde.setMinutes(0);
  //   fecha2 = fechadesde.setSeconds(1);
  //   let hasta = fechadesde.setHours(23);
  //   hasta = fechadesde.setMinutes(59);
  //   hasta = fechadesde.setSeconds(59);
  //   const fh = new Date(hasta);
  //   const fd = new Date(fecha2);
  //   this.facturaReporteService.getExcelFacturasIngresoEgreso(this.escuela.id, this.filtroTexto, fd, fh, true);
  // }

  // getDate(fecha){
  //   var targetTime = new Date(fecha);
  //   //get the timezone offset from local time in minutes
  //   var tzDifference = targetTime.getTimezoneOffset();
  //   //convert the offset to milliseconds, add to targetTime, and make a new Date
  //   var offsetTime = new Date(targetTime.getTime() + tzDifference * 60 * 1000);
  //   return offsetTime;
  // }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.alumnoSubscription) {
      this.alumnoSubscription.unsubscribe();
    }
    this.subscriptions.forEach(s => s.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }
}
